import { render, staticRenderFns } from "./QuestionsBank.vue?vue&type=template&id=b23ac974"
import script from "./QuestionsBank.vue?vue&type=script&lang=js"
export * from "./QuestionsBank.vue?vue&type=script&lang=js"
import style0 from "./QuestionsBank.vue?vue&type=style&index=0&id=b23ac974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports